import dayjs from "@/shared/utils/day";
import { entityIdsOf, entityMapOf } from "@/widgets/shared/utils/entity-utils";

export function state() {
  return {
    ids: [],
    days: {},
    selectedId: null,
    preselectedDateString: null,
  };
}

export const mutations = {
  setDays(state, { days, preselectedDayId = null }) {
    const idsToSet = entityIdsOf(days);
    const daysToSet = entityMapOf(days);
    const selectedId = idsToSet.indexOf(preselectedDayId);
    state.ids = idsToSet;
    state.days = daysToSet;
    if (selectedId !== -1) {
      state.selectedId = preselectedDayId;
    }
  },

  selectById(state, id) {
    state.selectedId = id || null;
  },

  selectByIndex(state, index) {
    const id = state.ids[index];
    state.selectedId = id || null;
  },
};

function sortDays(days) {
  return days.sort((a, b) => Date.parse(a.only_date) - Date.parse(b.only_date));
}

export const actions = {
  async setDays({ state, commit, dispatch }, { days, preselectedDayId = null }) {
    if (days) {
      const sortedDats = sortDays(days);

      if (days.length && !days.find(day => day.id === state.selectedId)) {
        await dispatch("setNearestDay", days);
      }
      await commit("setDays", { days: sortedDats, preselectedDayId: preselectedDayId });
    }
  },

  async setNearestDay({ dispatch, commit, getters, rootGetters, rootState }, days) {
    const timezone = rootState.timezone;
    const currentComponentId = rootState.agendas.selectedId;

    if (days && days.length) {
      const currentMoment = dayjs().tz(timezone);
      const currentTimestamp = currentMoment.valueOf();
      let foundDay;
      for (let index = 0; index < days.length; index++) {
        const day = days[index];
        //MA agenda day has 24 + 12hours, it's done that way, because a lot of music festivals has sessions after midnight and they should be present in the same day
        const dayEndTimestamp = dayjs.tz(day.only_date, timezone).add(36, "hours").valueOf();
        if (currentTimestamp <= dayEndTimestamp) {
          foundDay = day;
          break;
        }
      }
      const dayToSelect = foundDay || days[days.length - 1];
      const sessionsFromDayToSelect = rootGetters["sessions/visibleSessions"](currentComponentId, dayToSelect.id);
      const selectNextDay = hasAllSessionsFinished(sessionsFromDayToSelect);
      if (selectNextDay) {
        const followingDay = getFollowingDay(days, dayToSelect);
        if (followingDay) {
          await commit("selectById", followingDay.id);
        } else {
          await commit("selectById", dayToSelect.id);
        }
      } else {
        await commit("selectById", dayToSelect.id);
      }
    }
  },
};

function hasAllSessionsFinished(sessions) {
  const currentDate = new Date();
  return sessions.every(session => new Date(session.time_end) < currentDate);
}

function getFollowingDay(days, currentDay) {
  const currentDayDate = new Date(currentDay.only_date);
  return days.find(day => new Date(day.only_date) > currentDayDate);
}

export const getters = {
  dayById: state => id => state.days[id],

  allDays(state, getters) {
    return state.ids.map(getters.dayById);
  },

  activeDay(state, getters) {
    const id = state.selectedId;
    return getters.dayById(id);
  },

  activeDayIndex(state) {
    const id = state.selectedId;
    return state.ids.indexOf(id);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
